// extracted by mini-css-extract-plugin
export default {"container":"Check_container__jy2qj","icon":"Check_icon__NX+-J","sel":"Check_sel__+IfJz"};